import React, { useState, useEffect } from "react";
import DataService from "../../../../../Service";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Chip from "@material-ui/core/Chip";
import CustomSelect from "../../../../../Components/CustomSelect";
import Divider from "@material-ui/core/Divider";
import CustomInput from "../../../../../Components/CustomInput";
import Typography from "@material-ui/core/Typography";
import { Link } from "@material-ui/core";
import Loader from "../../../../../Components/Loader";
import {
  AddCircleOutlineOutlined,
  RemoveCircleOutlineOutlined,
} from "@material-ui/icons";
import { Collapse, Zoom, Checkbox } from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Placeholder } from "react-select/animated";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#fff",
    color: "#232323",
    boxShadow: "0px 3px 6px #232323",
  },
  backButton: {
    marginRight: theme.spacing(2),
  },
  wrapper: {
    margin: "3%",
  },
  detail: {
    padding: "3%",
    backgroundColor: "#fff",
    boxShadow: "0px 3px 6px #232323",
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,

    "& label": {
      position: "absolute",
      top: "12px",
      left: "8px",
      fontSize: "13px",
      color: "gray",
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  textAreaEmpty: {
    width: "100%",
    paddingTop: "0",
    border: "1px solid rgb(112, 112, 112)",
    borderRadius: "4px",
  },
  bottomBar: {
    boxShadow: "0px 0px 6px #232323",
    padding: "15px",
    textAlign: "center",
    margin: "0 -24px",
    marginTop: "10px",
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    zIndex: 1075,
    backgroundColor: "#fff",
  },
  chipComponent: {
    margin: "0.6rem",
    borderRadius: "5px",
    "& svg": {
      marginTop: "-30%",
      marginRight: "-20%",
      color: "var(--unnamed-color-ffffff)",
    },
  },
  attendance: {
    display: "flex",
    alignItems: "baseline",
    "& .MuiFormControl-root": {
      width: "25%",
    },
  },
  dimension: {
    "& > div:first-child": {
      marginTop: "20px",
    },
  },
  showDesc: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    cursor: "pointer",
    "& > svg": {
      marginRight: "5px",
    },
  },
  showDescription: {
    margin: "15px 0 30px",
  },
  buttonCss: {
    textTransform: "capitalize",
    width: "128px",
    height: "40px",
    fontWeight: 900,
  },
}));

const CoachingProgramDimension = (props) => {
  const { currentSelection, fetchApiFlag } = props;
  const classes = useStyles();
  const [coachingData, setCoachingData] = useState([]);
  const [nextButtonLoading, setNextButtonLoading] = useState(false);
  const [coachingDimensionLoading, setCoachingDimensionLoading] =
    useState(false);
  const [coachingProgrames, setCoachingProgrames] = useState([]);
  const [templateInfo, setTemplateInfo] = useState();
  const [coachingDimensionValue, setCoachingDimensionValue] = useState(
    "delivered_to_preferences"
  );

  const attendeesEnum = [
    "Coach",
    "Coachee",
    "HR",
    "HRBP",
    "Line Manager",
    "Acuity team",
    "Stakeholders",
  ];
  const minuteData = ["hour", "hours", "minute", "minutes"];

  useEffect(() => {
    fetchProgramDimension();
  }, [fetchApiFlag]);

  useEffect(() => {
    fetchProgramInfo();
  }, []);

  const fetchProgramInfo = () => {
    if (props?.action == "editMaster") {
      DataService.getData(
        { master_template_id: currentSelection?.id },
        `fetch_program_info`
      ).then((res) => {
        if (res.success) {
          setTemplateInfo(res?.master_template_pgm_info);
        }
      });
    } else {
      DataService.getData(
        { programme_id: currentSelection?.id },
        `program_info`
      ).then((res) => {
        if (res.success) {
          setTemplateInfo(res?.programme_info);
        }
      });
    }
  };

  useEffect(() => {
    coachingProgrames.map((data) => {
      if (data?.module_name === "midpoint") {
        if (Boolean(data?.delivered_to_preferences)) {
          setCoachingDimensionValue(data?.delivered_to_preferences);
        } else {
          setCoachingDimensionValue(data?.fixed_session_length);
        }
      }
    });
  }, [coachingProgrames]);

  useEffect(() => {
    if (templateInfo) {
      if (templateInfo?.programme_info_modules?.length) {
        let templateInfoSortedArray = Array.from(
          templateInfo?.programme_info_modules
        ).sort((a, b) => a.module_name.localeCompare(b.module_name));
        setCoachingProgrames(templateInfoSortedArray);
      } else if (templateInfo?.master_template_modules?.length) {
        let templateInfoSortedArray = Array.from(
          templateInfo?.master_template_modules
        ).sort((a, b) => a.module_name.localeCompare(b.module_name));
        setCoachingProgrames(templateInfoSortedArray);
      }
    }
  }, [
    templateInfo?.programme_info_modules?.length,
    templateInfo?.master_template_modules?.length,
  ]);

  const fetchProgramDimension = () => {
    if (props?.action == "editMaster") {
      setCoachingDimensionLoading(true);
      setTimeout(
        () =>
          DataService.getData(
            { master_template_id: currentSelection?.id },
            `fetch_coaching_dimension`
          )
            .then((res) => {
              if (res?.success) {
                props?.setStepperData(
                  res?.header_name || "Coaching program dimensions"
                );
                props?.setHeaderType("program_dimension");
                setCoachingDimensionLoading(false);
                setCoachingData(res?.master_template_modules);
              }
            })
            .catch((error) => {
              setCoachingDimensionLoading(false);
            }),
        1000
      );
    } else {
      setCoachingDimensionLoading(true);
      setTimeout(
        () =>
          DataService.getData(
            { programme_id: currentSelection?.id },
            `coaching_dimensions`
          )
            .then((res) => {
              if (res?.success) {
                props.setStepperData(
                  res?.header_name || "Coaching program dimensions"
                );
                props?.setHeaderType("program_dimension");
                props?.setFetchApiFlag(false);
                setCoachingDimensionLoading(false);
                setCoachingData(res?.programme_info_modules);
              }
            })
            .catch((error) => {
              setCoachingDimensionLoading(false);
            }),
        1000
      );
    }
  };

  useEffect(() => {
    if (coachingData?.length) {
      const updatedData = coachingProgrames.map((item) => {
        return {
          ...item,
          ...coachingData.find((cItem) => cItem.module_id === item.module_id),
        };
      });
      setCoachingProgrames([...updatedData]);
    }
  }, [coachingData]);

  const handleChange = (name, index, value) => {
    const coachingData = [...coachingProgrames];
    const tObj = coachingData[index];
    if (name === "attendees") {
      const oldAttendees = [];
      if (tObj?.attendees?.length) oldAttendees.push(...tObj.attendees, value);
      else oldAttendees.push(value);
      tObj[name] = oldAttendees;
    } else {
      tObj[name] = value;
    }
    coachingData[index] = tObj;
    setCoachingProgrames(coachingData);
  };

  const handleChangeRadioValue = (event, data, index) => {
    const { name, value } = event.target;
    setCoachingDimensionValue({ [name]: value });
    const coachingData = [...coachingProgrames];
    const tObj = coachingData[index];
    if (tObj?.module_name === "midpoint") {
      tObj["delivered_to_preferences"] = Boolean(
        name == "delivered_to_preferences"
      );
      tObj["fixed_session_length"] = Boolean(name == "fixed_session_length");
    }
    coachingData[index] = tObj;
    setCoachingProgrames(coachingData);
  };

  const handleDelete = (mainIndex, chipIndex) => {
    const coachingData = [...coachingProgrames];
    const tObj = coachingData[mainIndex];
    tObj.attendees.splice(chipIndex, 1);
    coachingData[mainIndex] = tObj;
    setCoachingProgrames(coachingData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setNextButtonLoading(true);
    const coach_dimensions = coachingProgrames;
    if (props?.action == "editMaster") {
      let obj = {
        coach_dimensions,
        master_template_id: currentSelection?.id,
      };
      DataService.updateData(obj, "", "coaching_dimensions")
        .then((res) => {
          if (res?.success) {
            setNextButtonLoading(false);
            // setAction('create')
            props.onNextClick();
          }
        })
        .catch((error) => {
          setNextButtonLoading(false);
        });
    } else {
      const obj = {
        coach_dimensions,
        programme_id: currentSelection?.id,
      };
      DataService.updateData(obj, "", "update_coaching_dimensions")
        .then((res) => {
          if (res?.success) {
            setNextButtonLoading(false);
            // fetchProgramDimension();
            // fetchProgramInfo();
            props.onNextClick();
          }
        })
        .catch((error) => {
          setNextButtonLoading(false);
        });
    }
  };
  return (
    <>
      <form spellCheck="false" onSubmit={handleSubmit}>
        <Container maxWidth="xl" className={classes.dimension}>
          {coachingDimensionLoading && <Loader />}
          {coachingProgrames.map((data, index) => {
            const chipsItem = attendeesEnum.filter(
              (item) => !data?.attendees?.includes(item)
            );
            return (
              <Grid container justify="space-between">
                <Grid item xs={6}>
                  <Grid container>
                    <Grid item xs={4} style={{ paddingTop: "16px" }}>
                      {!index && (
                        <Typography variant="h2" style={{ fontWeight: "bold" }}>
                          Coaching dimensions
                        </Typography>
                      )}
                      <Typography variant="h2" style={{ paddingTop: "16px" }}>
                        {data?.module_name}
                      </Typography>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={8}
                      alignItems="center"
                      style={{ paddingTop: "16px" }}
                    >
                      {!index && (
                        <Grid xs={12}>
                          <Typography
                            variant="h2"
                            style={{ fontWeight: "bold" }}
                          >
                            Duration
                          </Typography>
                        </Grid>
                      )}
                      <Grid item xs={4} style={{ paddingTop: "16px" }}>
                        <TextField
                          id="outlined-basic"
                          key={index}
                          name={`duration`}
                          onChange={(e) =>
                            handleChange(`duration`, index, e.target.value)
                          }
                          label=""
                          variant="outlined"
                          defaultValue={data?.duration}
                          value={data?.duration}
                          required
                        />
                      </Grid>
                      <Grid item xs={4} style={{ paddingTop: "16px" }}>
                        <FormControl
                          variant="outlined"
                          className={classes.formControl}
                        >
                          <CustomSelect
                            defaultValue={data?.time_format}
                            id="time_format"
                            labelText="Duration"
                            displayEmpty
                            variant="outlined"
                            itemArr={minuteData}
                            parentcall={(obj) =>
                              handleChange(`time_format`, index, obj.value)
                            }
                            required
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid xs={4} />
                    <Grid container item xs={8} alignItems="center">
                      <Grid item xs={4}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="enable_billing"
                              color="primary"
                              checked={Boolean(data?.enable_billing)}
                            />
                          }
                          onChange={(e) =>
                            handleChange(
                              `enable_billing`,
                              index,
                              e.target.checked
                            )
                          }
                          label={
                            <Typography variant="h2">Chargeable</Typography>
                          }
                          className={classes.paper}
                        />
                      </Grid>
                      <Grid item xs={8}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="include_total_hour"
                                                            color="primary"
                                                            checked={Boolean(data?.include_total_hour)}
                                                        />
                                                    }
                                                    onChange={(e) => handleChange(`include_total_hour`, index, e.target.checked)}
                                                    label={<Typography variant="h2">Include in total program hours</Typography>}
                                                    className={classes.paper}
                                                />
                                            </Grid>
                    </Grid>
                    <Grid xs={4} />
                    <Grid container item xs={8} alignItems="center">
                      <Grid item xs={10}>
                        <Collapse
                          in={
                            data?.showDesc || data?.description ? true : false
                          }
                        >
                          <CustomInput
                            style={{ marginTop: "24px" }}
                            id="description"
                            name="description"
                            variant="outlined"
                            placeholder="Description"
                            multiline={true}
                            rows={8}
                            parentcall={(val) =>
                              handleChange(`description`, index, val)
                            }
                            defaultValue={data?.description}
                          />
                        </Collapse>
                        <Typography
                          variant="h2"
                          className={classes.showDescription}
                        >
                          <Link
                            className={classes.showDesc}
                            onClick={() =>
                              handleChange(
                                `showDesc`,
                                index,
                                data?.showDesc ? !data?.showDesc : true
                              )
                            }
                          >
                            {data?.showDesc || data?.description ? (
                              <RemoveCircleOutlineOutlined />
                            ) : (
                              <AddCircleOutlineOutlined />
                            )}{" "}
                            Add Description
                          </Link>
                        </Typography>
                      </Grid>
                    </Grid>
                    {data?.module_name === "midpoint" && (
                      <>
                        <Grid xs={4} />
                        <Grid>
                          <Grid xs={12}>
                            <RadioGroup
                              value={coachingDimensionValue}
                              onChange={(event) => {
                                handleChangeRadioValue(event, data, index);
                              }}
                            >
                              <Grid container spacing={2} direction="row">
                                <Grid xs={4}>
                                  <FormControlLabel
                                    checked={
                                      coachingDimensionValue?.delivered_to_preferences ||
                                      data?.delivered_to_preferences
                                    }
                                    value="delivered_to_preferences"
                                    id="delivered_to_preferences"
                                    name="delivered_to_preferences"
                                    control={<Radio color="primary" />}
                                    label={
                                      <Typography variant="h2">
                                        Delivered to preferences
                                      </Typography>
                                    }
                                    className={classes.paper}
                                  />
                                </Grid>
                                <Grid xs={6}>
                                  <FormControlLabel
                                    checked={
                                      coachingDimensionValue?.fixed_session_length ||
                                      data?.fixed_session_length
                                    }
                                    id="fixed_session_length"
                                    name="fixed_session_length"
                                    value="fixed_session_length"
                                    control={<Radio color="primary" />}
                                    label={
                                      <Typography variant="h2">
                                        Fixed session length
                                      </Typography>
                                    }
                                    className={classes.paper}
                                  />
                                </Grid>
                              </Grid>
                            </RadioGroup>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
                <Divider orientation="vertical" style={{ height: "revert" }} />
                <Grid item xs={5} direction="row" alignItems="flex-start">
                  <Grid container>
                    {!index && (
                      <Grid xs={12}>
                        <h3>Attendees</h3>
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <div className={classes.attendance}>
                        <FormControl
                          variant="outlined"
                          className={classes.formControl}
                        >
                          <label>Select</label>
                          <Select
                            id="attendees"
                            name={"attendees"}
                            value={""}
                            variant="outlined"
                            itemArr={chipsItem}
                            disabled={!chipsItem.length}
                            onChange={(obj) => {
                              obj.target.value &&
                                handleChange(
                                  `attendees`,
                                  index,
                                  obj.target.value
                                );
                            }}
                          >
                            {chipsItem?.map((option) => {
                              return (
                                <MenuItem value={option}>
                                  <Typography variant="h2">{option}</Typography>
                                </MenuItem>
                              );
                            })}
                          </Select>

                          {/*<InputLabel>Attendees</InputLabel>*/}
                          {/*<CustomSelect*/}
                          {/*    // placeholder={"Attendees"}*/}
                          {/*    id="attendees"*/}
                          {/*    // labelText="Attendees"*/}
                          {/*    displayEmpty*/}
                          {/*    variant="outlined"*/}
                          {/*    itemArr={chipsItem}*/}
                          {/*    disabled={!chipsItem.length}*/}
                          {/*    parentcall={(obj) => obj?.value && handleChange(`attendees`, index, obj.value)}*/}
                          {/*/>*/}
                        </FormControl>
                        <div>
                          {data &&
                            data?.attendees?.map((item, cIndex) => (
                              <Zoom in>
                                <Chip
                                  key={index}
                                  className={classes.chipComponent}
                                  label={item}
                                  onDelete={() => handleDelete(index, cIndex)}
                                />
                              </Zoom>
                            ))}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Container>
        <div className={classes.bottomBar}>
          <Button
            onClick={() => props.handleClose()}
            className={classes.buttonCss}
            style={{ marginRight: "10px" }}
            disabled={nextButtonLoading}
            type="submit"
            variant="contained"
          >
            Close
          </Button>
          <Button
            className={classes.buttonCss}
            disabled={nextButtonLoading}
            variant="contained"
            type={"submit"}
            color="secondary"
          >
            Next
          </Button>
        </div>
      </form>
    </>
  );
};

export default CoachingProgramDimension;
